import React, { useState,useRef }  from 'react'
import Loader from './Loader'
import md5 from '../md5';
import {loaddat,localestr} from '../utils'
//import { version } from '../../package.json'
import packageInfo from '../../package.json';
import logo from '../logo.svg' 
//import label from '../label.svg' 
import icon from '../icons.svg'; 


  //import './header.css'

  //тут би ще дописати переключатель мов

function AuthForm({status,inUser,loginData,setLogin,setTime}){
    const targetRef = useRef()

    if (status==='UsrChoise') if (loginData.users.length>0) {
        /*for (let i=0;i<loginData.users.length;i++){
            if (loginData.users[i].name===inUser) {
                break
            }
        } */
    }

    const [Loading, setLoading] = useState(false)
    const [Pass, setPass] = useState('')
    const [Buff, setBuff] = useState('')
    

    function changeHandler(data,setLogin) {
        setLoading(true)
        setLogin({status:'setPass',pass:Pass})
        loaddat("action=init&data="+JSON.stringify(data),(d)=>{setLoading(false);setLogin(d)})
    }

    function changePass(data){
    if (data) {
        const clean = data.replace(/[^a-zA-Z0-9]/g, '');
        setPass(md5(clean));
    }
}

    function setFocus(el){
        if (!el) return
        el.focus()
    }

    function btnClick(val){
        /*const targ=document.getElementById('pass')
        if(!targ) return
        if(!val) targ.value=''
        else if(val==='-') targ.value=targ.value.slice(0,-1)
        else targ.value+=val
        targ.focus()
        changePass(targ.value)*/
        let vl=Buff
        if(!val) vl=''
        else if(val==='-') vl=Buff.slice(0,-1)
        else vl=Buff+val
        setBuff(vl)
        setTimeout(()=>changePass(vl),20)
    }

    const newKey=(e)=>{
        if(e.key==='Enter'){
            setTimeout(()=>changeHandler({pass:md5(Buff)},setLogin),40)
            return
        }
        if(e.key==='Backspace' && Buff.length){
            let vl=Buff.substring(0,Buff.length-1)
            setBuff(vl)
            setTimeout(()=>changePass(vl),20)
            return
        }
        if(e.key.length>1&&e.key!=='Shift') return
        let vl=(Buff+e.key).replace('Shift/','?').replace('?Shift','?')
        setBuff(vl)
        //console.log(vl)
        setTimeout(()=>changePass(vl),15)
    }

    let cont=<div>Введіть код</div>
    if(Buff){
        cont=[]
        for(let i=0; i<Buff.length; i++) cont.push(<div key={i} style={{border:'none',width:'14px',minWidth:'12px',height:'14px',margin:'4px',borderRadius:'10px',background:'var(--black-tx-color)'}}></div>)
    }
    
    if (Loading) return <Loader />
    if (status==='UsrChoise'){
        const timekeeping=parseInt(localStorage.getItem('timekeeping') || 0)
        let timekeeper=null
        if(timekeeping){
            timekeeper=<div style={{position:'absolute',left:'20px',display:'flex',flexDirection:'column',alignItems:'center'}}>
            <div style={{display:'inline-block',verticalAlign:'bottom',width:'150px'}} className={'black_btn'} onClick={setTime}><div style={{height:'48px',lineHeight:'48px',display:'block'}}>{localestr('Табелювання')}</div></div>
            </div>
        }
        return <div className='login_div' tabIndex='0' ref={el=>{setFocus(el);return targetRef}} onKeyUp={(e)=>{newKey(e)}}>
            <table><tbody>
            <tr><td colSpan={2} style={{border:'none',textAlign:'center'}}>
                <div style={{display:'inline-block'}}><img style={{width:'168px'}} align='left' src={logo} alt=''/></div><br />
                {/*<span style={{fontWeight:'bold'}}>Coctail</span><br />
                <span><img style={{height:'25px'}} src={label} alt=''/></span><br />*/}
                <span style={{fontWeight:'bold'}}>front office</span> &nbsp; 
                <span style={{fontSize:'small'}}>{localestr('Версія')}: {packageInfo.version}</span>
                
            </td></tr>
            <tr><td  colSpan='2' style={{border:'none'}}>
            
            <div style={{height:'32px',margin:'5px 10px',fontWeight:'bold',color:'var(--dark-tx-color)',padding: '5px',border:'solid 1px var(--dark-tx-color)',borderRadius:'30px',display:'flex',justifyContent:'center',alignItems:'center',maxWidth:'240px',overflow:'hidden'}}>
                {cont}
            </div>
            
            </td></tr>
            <tr><td colSpan='2' style={{textAlign:'center', border:'none',paddingTop:'10px'}}>
                <div className={'login_btn'} onClick={()=>{btnClick('1')}}><div>1</div></div>
                <div className={'login_btn'} onClick={()=>{btnClick('2')}}><div>2</div></div>
                <div className={'login_btn'} onClick={()=>{btnClick('3')}}><div>3</div></div><br />
                <div className={'login_btn'} onClick={()=>{btnClick('4')}}><div>4</div></div>
                <div className={'login_btn'} onClick={()=>{btnClick('5')}}><div>5</div></div>
                <div className={'login_btn'} onClick={()=>{btnClick('6')}}><div>6</div></div><br />
                <div className={'login_btn'} onClick={()=>{btnClick('7')}}><div>7</div></div>
                <div className={'login_btn'} onClick={()=>{btnClick('8')}}><div>8</div></div>
                <div className={'login_btn'} onClick={()=>{btnClick('9')}}><div>9</div></div><br />
                <div style={{border:'none',background:'none'}} className={'login_btn'} onClick={()=>{btnClick('-')}}><div><img style={{width:'32px',height:'32px',paddingTop:'14px'}} src={icon+'#key_b'} alt='' /></div></div>
                <div className={'login_btn'} onClick={()=>{btnClick('0')}}><div>0</div></div>
                <div style={{border:'none',background:'none'}} className={'login_btn'} onClick={()=>{btnClick('')}}><div><img style={{width:'24px',height:'24px',paddingTop:'18px'}} src={icon+'#calcx'} alt='' /></div></div>
            </td></tr>
            <tr><td colSpan='2' style={{textAlign:'center', border:'none',paddingTop:'10px'}}><div style={{display:'inline-block',verticalAlign:'bottom'}} className={'black_btn'} onClick={()=>{changeHandler({pass:Pass},setLogin)}}><div style={{height:'48px',lineHeight:'48px',display:'block'}}>{localestr('Увійти')}</div></div></td></tr>
            {/*<tr><td colSpan='2' style={{textAlign:'center', border:'none'}}><button type='submit' onClick={()=>{changeHandler({user:usr,pass:Pass},setLogin)}}>&nbsp; OK &nbsp;</button></td></tr>*/}
            </tbody></table>{timekeeper}</div>
    } else {
        return <div>{localestr('Помилка авторизації!')}</div>
    }

}

export default AuthForm

